module.exports = __webpack_public_path__ + "static/media/WelcomeMessageFromMichael.bf42ac7c.mp3";